export interface AnnualRateRow {
  state_code: string
  year: number
  rate_cents_kwh: number | string
  source?: string | null
  rate_provenance?: unknown
}

export interface AnnualRateTrend {
  startYear: number
  endYear: number
  startRateCentsKwh: number
  endRateCentsKwh: number
  changePercent: number
}

/** Shared plain text for the visible answer and the LLM description. */
export function annualRateTrendText(trend: AnnualRateTrend, stateName: string): string {
  const direction = trend.changePercent === 0 ? 'were unchanged' :
    `${trend.changePercent > 0 ? 'increased' : 'decreased'} by ${Math.abs(trend.changePercent).toFixed(1)}%`
  return `EIA annual residential electricity averages for ${stateName} ${direction}, from ${trend.startRateCentsKwh.toFixed(2)}¢/kWh in ${trend.startYear} to ${trend.endRateCentsKwh.toFixed(2)}¢/kWh in ${trend.endYear}. These are the latest two source-verified annual observations available here; they are separate from the current monthly state rate. Source: U.S. Energy Information Administration, analyzed by Fridge.com.`
}
